import { useState } from "react";
import { Space, Table, Tag } from 'antd';
import HeroPages from "../components/HeroPages";
import { COLUMN_HEADER_PRICING, DESTINATIONS, COLUMN_HEADER_VEHICLES, VEHICLE_DATA } from "../components/CarData";
import { Tabs, ConfigProvider } from 'antd';

function Pricing () {
    const [activeTab, setActiveTab] = useState('1');
    const [items, setItems] = useState([
        {
          label: 'Self Drive Cars',
          key: '1',
        },
        {
          label: 'Drop-Off Transportation',
          key: '2',
        },
    ]);

    return(
    <section id="home" className="hero-section">
        <HeroPages name="Pricing" />
        <div className="container">
            <ConfigProvider
                theme={{
                  components: {
                    Tabs: {
                      itemActiveColor:"#ffffff",
                      itemSelectedColor:"#ffffff"
                    },
                  },
                }}
              >
            <Tabs
                defaultActiveKey="1"
                type="card"
                size="large"
                style={{
                    marginBottom: 32,
                }}
                items={items}
                onChange={setActiveTab}/>
            </ConfigProvider>

            {
            (activeTab === "2") &&
            <Table 
                columns={COLUMN_HEADER_PRICING} 
                dataSource={DESTINATIONS}
                showSorterTooltip={{
                target: 'sorter-icon',
                }}/>
            }

            {
            (activeTab === "1") &&
            <Table 
                columns={COLUMN_HEADER_VEHICLES} 
                dataSource={VEHICLE_DATA}
                showSorterTooltip={{
                target: 'sorter-icon',
                }}/>
            }
        </div>
    </section>
    );
};
export default Pricing;